import _ from 'lodash';

export default {
    loadUserEvents: function(eventsArray, fetchTime) {
        if (!_.isArray(eventsArray)) eventsArray = [eventsArray];
        return {type: 'USER_EVENTS_LOADED', events: eventsArray, fetchTime};
    },
    // this just prevents a foreach when getting data from server; may be removed in the future if nothing else is gained
    updateEvents: function(eventsArray, fetchTime) {
        if (!_.isArray(eventsArray)) eventsArray = [eventsArray];
        return {type: 'EVENTS_UPDATE', events: eventsArray, fetchTime};
    },
    // use this one when receiving data from the server
    singleEventUpdate: function(event, fetchTime) {
        return {type: 'SINGLE_EVENT_UPDATE', eventId: event.id, event, fetchTime};
    },
    /**
     * Update community subevent data
     * NOTE: do not call directly; this is called by singleEventUpdate where applicable
     */
    subEventUpdate: function (event) {
        return {type: 'SUB_EVENT_UPDATE', event}
    },
    // use this to update some local property of the event (no data recalculations performed)
    localUpdate: function (eventId, event) {
        return {type: 'EVENT_LOCAL_UPDATE', eventId, event};
    },
    updateQuestionCategory: function(eventId, questionCategoryId, payload) {
        return {type: 'UPDATE_QUESTION_CATEGORY', eventId, questionCategoryId, payload};
    },
    deleteEvent: function(eventId) {
        return {type: 'EVENTS_DELETE', eventId};
    },
    updateUserEvent: function(eventId, {date_created, is_joined, listing_status, open_enrichments_count, user}) {
        return {
            type: 'EVENTS_UPDATE_USER_EVENT',
            eventId,
            userEvent: {
                date_created,
                is_joined,
                listing_status,
                open_enrichments_count,
                user,
            },
        };
    },
    joinEvent: eventId => ({type: 'EVENT_CHANGE_PARTICIPANCE', eventId, joined: true}),
    leaveEvent: eventId => ({type: 'EVENT_CHANGE_PARTICIPANCE', eventId, joined: false})
};
